// extracted by css-extract-rspack-plugin
export default {"emboldened":"ContentfulRiver-module__emboldened__zwSzMfk"};